<template>
  <v-col md="6">
    <div class="mt-5 mb-3">
      <h2>계정정보</h2>
    </div>
    <v-simple-table class="mr-2">
      <template>
        <thead>
          <tr class="table_wrap">
            <th class="text-left table_title pa-4" style="border-top: 1px solid rgb(0, 0, 0);
              color: #000;
              font-size: 16px;">
              로그인ID
            </th>
            <th class="text-left table_text" style="border-top: 1px solid rgb(0, 0, 0);
              font-size: 16px;
              font-weight:400;">
              {{ userInfo.email }}
            </th>
          </tr>
          <tr>
            <th class="text-left table_title pa-4" style="color: #000;
              font-size: 16px;">
              CMS 접속 URL
            </th>
            <th class="text-left table_text" style="font-size: 16px;
              font-weight:400;">
              <div>
                {{ url }}
                <v-btn icon class="ml-1" small @click="copyToClipboard(url)">
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </div>
            </th>
          </tr>
          <tr>
            <th class="text-left table_title pa-4" style="color: #000;
                font-size: 16px;">
              계정권한
            </th>
            <th class="text-left table_text" style="padding-top: 10px; padding-bottom: 10px; padding-left: 8px;">
              <v-row>
                <v-col v-for="(item, index) in userMenu" :key="index" cols="auto">
                  <router-link v-show="showAllChips || index < maxVisibleChips" :to="item.to" class="ma-1">
                    <Chips :chipText="item.title" />
                  </router-link>
                </v-col>
                <v-btn v-if="userMenu.length > maxVisibleChips" icon @click="toggleChipsVisibility" small>
                <v-icon>{{ showAllChips ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
              </v-row>

              
            </th>
          </tr>
          <tr>
            <th class="text-left table_title pa-4" style="color: #000;
              font-size: 16px;">
              최종로그인
            </th>
            <th class="text-left table_text" style="font-size: 16px;
              font-weight:400;">
              {{ userInfo.updated_at }}
            </th>
          </tr>
          <tr>
            <th class="text-left table_title pa-4" style="border-bottom: 1px solid rgb(0, 0, 0);
              color: #000;
              font-size: 16px;">
              최종 로그인 IP
            </th>
            <th class="text-left table_line" style="border-bottom: 1px solid rgb(0, 0, 0);
              font-size: 16px;
              font-weight:400;">
              {{ ip }}
            </th>
          </tr>
        </thead>
      </template>
    </v-simple-table>
  </v-col>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Chips from '@/components/ui/chips/Chips.vue';

export default {
  components: {
    Chips
  },
  data() {
    return {
      url: window.location.protocol + '//' + window.location.hostname,
      showAllChips: false,
      maxVisibleChips: 5,
    }
  },
  computed: {
    ...mapState('dashboard', {
      userInfo: state => state.userInfo,
      userMenu: state => state.userMenu,
      ip: state => state.ip,
      tencent: state => state.tencent,
      errorMessage: state => state.errorMessage,
    }),
  },
  methods: {
    ...mapActions('dashboard', ['data']),
    copyToClipboard(textToCopy) {
      this.$copyText(textToCopy)
    },
    toggleChipsVisibility() {
      this.showAllChips = !this.showAllChips;
    },
    navigateTo(to) {
      this.$router.push(to);
    }
  },
  created() {
    this.data();
  }
}
</script>

<style lang="scss" scoped></style>